export const DINING_LOCATION = 'DINING_LOCATION';
export const DINING_LOCATION_SUCCESS = 'DINING_LOCATION_SUCCESS';
export const DINING_LOCATION_ERROR = 'DINING_LOCATION_ERROR';

export const ADD_DINING_LOCATION = 'ADD_DINING_LOCATION';
export const ADD_DINING_LOCATION_SUCCESS = 'ADD_DINING_LOCATION_SUCCESS';
export const ADD_DINING_LOCATION_ERROR = 'ADD_DINING_LOCATION_ERROR';

export const UPDATE_DINING_LOCATION = 'UPDATE_DINING_LOCATION';
export const UPDATE_DINING_LOCATION_SUCCESS = 'UPDATE_DINING_LOCATION_SUCCESS';
export const UPDATE_DINING_LOCATION_ERROR = 'UPDATE_DINING_LOCATION_ERROR';

export const DELETE_DINING_LOCATION = 'DELETE_DINING_LOCATION';
export const DELETE_DINING_LOCATION_SUCCESS= 'DELETE_DINING_LOCATION_SUCCESS';
export const DELETE_DINING_LOCATION_ERROR ='DELETE_DINING_LOCATION_ERROR';
